import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['area', 'chunk', 'speedLabel', 'speedRange',
                    'averageSpeed', 'timeTaken', 'totalWords', 'result',
                    'pauseButton', 'startButton', 'controls',
                    'saveForm', 'resetForm', 'done', 'instruction' ]

  initialize() {
    this.timeSpent = 0
    this.timer = 0
    this.speedChanged = false
  }

  start() {
    this.areaTarget.scrollTop = 0
    this.pauseButtonTarget.classList.remove('d-none')
    this.startButtonTarget.classList.add('d-none')
    this.startAt = new Date()
    this.revealChunk()
  }

  revealChunk() {
    const revealed = this.revealedChunk
    if (revealed) {
      revealed.classList.remove('blockbuster-revealed')
      revealed.classList.add('blockbuster-read')
    }

    const chunk = this.nextChunk
    if (chunk) {
      chunk.classList.remove('blockbuster-covered')
      chunk.classList.add('blockbuster-revealed')

      this.scroll(chunk)

      const words = chunk.dataset.words
      const wpm = this.speed
      const delay = words * 60000 / wpm
      this.timer = setTimeout(() => { this.revealChunk() }, delay)
    } else {
      this.calculateTimeSpent()
      this.finish()
    }
  }

  scroll(chunk) {
    const paragraph = chunk.parentElement

    if (chunk === paragraph.firstChild) {
      const area = this.areaTarget
      const paragraphBottom = paragraph.offsetHeight + paragraph.offsetTop
      const areaBottom = area.scrollTop + area.clientHeight

      if (paragraphBottom > areaBottom) {
        area.scrollTop = paragraph.offsetTop - 5
      }
    }
  }

  pause() {
    this.pauseButtonTarget.classList.add('d-none')
    this.startButtonTarget.classList.remove('d-none')
    clearTimeout(this.timer)
    this.calculateTimeSpent()
  }

  calculateTimeSpent() {
    const endAt = new Date()
    this.timeSpent += (endAt - this.startAt)
  }

  get nextChunk() {
    return this.chunkTargets.find(span => {
      return span.classList.contains('blockbuster-covered')
    })
  }

  get revealedChunk() {
    return this.chunkTargets.find(span => {
      return span.classList.contains('blockbuster-revealed')
    })
  }

  changeSpeed () {
    this.speedLabelTarget.innerText = this.speed
    if (this.startAt) {
      this.speedChanged = true
    }
  }

  get speed() {
    return parseInt(this.speedRangeTarget.value)
  }

  get averageSpeed() {
    if (!this.speedChanged) {
      return this.speed
    } else {
      return (60000 * parseInt(this.totalWordsTarget.innerText)) / this.timeSpent
    }
  }

  finish() {
    // Submit the save form using native browser API
    this.saveFormTarget.requestSubmit()
    
    // Fire custom event
    this.element.dispatchEvent(new CustomEvent('exercisedone', { bubbles: true }))
    
    this.doneTarget.classList.remove('d-none')
    this.resetFormTarget.classList.remove('d-none')
    this.instructionTarget.classList.add('d-none')
    this.chunkTargets.forEach(span => { span.classList.remove('blockbuster-read') })

    this.controlsTarget.classList.add('d-none')
    this.resultTarget.classList.remove('d-none')
    this.timeTakenTarget.innerText = this.timeSpentFormatted
    this.averageSpeedTarget.innerText = Math.round(this.averageSpeed)
  }

  async reset(event) {
    // Prevent Turbo from handling the response (we're doing it manually)
    event.preventDefault()

    // Fire custom event before reset
    this.element.dispatchEvent(new CustomEvent('exercisereset', { bubbles: true }))
    
    let response
    
    // Turbo format: event.detail.fetchResponse.responseText is a Promise
    if (event.detail?.fetchResponse) {
      try {
        response = await event.detail.fetchResponse.responseText
      } catch (e) {
        console.error('Error extracting Turbo response:', e)
      }
    }
    
    if (response && typeof response === 'string' && response.trim().length > 0) {
      this.element.parentNode.innerHTML = response
      console.log('✓ Activity reset successful')
    } else {
      console.error('⚠️ Reset failed: No valid response', { detail: event.detail })
      alert('Failed to reset activity. Please refresh the page and try again.')
    }
  }

  get timeSpentFormatted() {
    const seconds = Math.floor(this.timeSpent/1000)
    const m = Math.floor(seconds/60)
    const s = seconds % 60
    return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s)
  }
}
